import pkg from '../../package.json';
export const environment = {
  production: false,
  env_name: 'test',
  recaptcha_site_key: '6LfBVx4rAAAAABpYl42r09-GPSmN9NtW8CvrX075',
  api_url: 'https:///nexus-test.erigo.be/nexus/api',
  ping_interval: 60000,
  app_version: pkg.version,
  azureAd: {
    // azure ad tenant id
    tenantId: 'cd619d6c-6cef-4eb8-b0aa-315936858d41',
    // front-end client id (for Uri, add api:// in front of the client id)
    clientAppId: '4e0f110a-184f-4353-8e53-da56a7c81409',
    // back-end application id
    apiAppId: '00b5ec83-51e5-4937-8b8e-5237d3e37d50',
    apiScope: 'nexus_api_access',
    // authority
    authority: 'https://login.microsoftonline.com/cd619d6c-6cef-4eb8-b0aa-315936858d41/v2.0',
    redirectUri: 'https://nexus-test.erigo.be/home',
    logoutRedirectUri: 'https://nexus-test.erigo.be/welcome',
  }
};
